<template>
    <div class="goods tableStyle">
        <el-form inline size="small">
            <el-form-item class="screen" label="商品名称：">
                <el-input v-model="queryParams.name" placeholder="请输入商品名称" clearable></el-input>
            </el-form-item>
            <el-form-item class="screen" label="所属分类：">
                <el-select v-model="queryParams.type" placeholder="请选择">
                    <el-option label="" value=""></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="screen" label="是否上架：">
                <el-select v-model="queryParams.online" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="screen" label="有无库存：">
                <el-select v-model="queryParams.left" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="无" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button plain>查询</el-button>
                <el-button plain>重置</el-button>
            </el-form-item>
        </el-form>
        <div>
            <el-button type="primary" size="small" @click="goEditGoods">新增分类</el-button>
        </div>

        <div class="tableArea">
            <el-table :data="tableData" style="width: 100%" height="100%">
                <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
                <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="name" label="所属分类" align="center"></el-table-column>
                <el-table-column prop="name" label="商品图片" align="center"></el-table-column>
                <!-- <el-table-column prop="name" label="库存" align="center"></el-table-column> -->
                <el-table-column prop="name" label="是否上架" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" plain @click="goOnline(scope.row)">上架</el-button>
                        <el-button type="primary" size="mini" @click="goEdit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini" plain @click="goDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pageFoot flex">
            <div class="tongji">
                统计：共{{total}}个
            </div>
            <el-pagination
                layout="total, prev, pager, next, sizes"
                background
                :page-size="queryParams.size"
                :total="total"
                :page-sizes="[20,50,100,200,500,1000]"
                @size-change="sizeChange"
                @current-change="changePage">
            </el-pagination>
        </div>

        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <el-form size="small" label-width="auto">
                <el-form-item label="分类名称：">
                    <el-input placeholder="请输入商品分类名称"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="handleClose">取 消</el-button>
                <el-button size="small" type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            queryParams:{
                page: 1,
                size: 20,
                name: '',
                type: '',
                online: '',
                left: '',
            },
            total: 0,
            tableData: [
                {
                    id: 1,
                    name: '电子产品'
                }
            ],
            dialogVisible: false
        }
    },
    methods: {
        init(){

        },
        // 获取table数据
        getTableList(){

        },
        // 新增、编辑商品
        goEditGoods(){
            let route = {
                name: '新增商品',
                path: {path: '/main/editGoods'}
            };
            this.$store.commit('setTag', route);
            this.$router.push(route.path);
        },
        sizeChange(val){

        },
        changePage(val){

        },
        openDialog(){
            this.dialogVisible = true;
        },
        handleClose(){
            this.dialogVisible = false;
        },
        // 上架
        goOnline(data){

        },
        // 编辑商品
        goEdit(data){

        },
        // 删除商品
        goDel(data){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                
            }).catch(() => {});
        },
    },
}
</script>
<style lang="less" scoped>
    .goods{
        height: 100%;

        .tableArea{
            height: calc(100% - 169px);
        }

        .pageFoot{
            justify-content: space-between;
            align-items: center;

            .tongji{
                font-size: 14px;
            }
        }
    }
    /deep/.el-table th.el-table__cell{
        background-color: #F4F5F7;
    }
</style>